export default __webpack_public_path__ + "static/media/Documents_Icon.a37650fd.svg";